import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { toast } from '../../../utils'

import { StoresContext } from '../../../provider/StoreProvider'
import { ModalContext } from '../../../provider/modalProvider'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function CalculateConfirmModal({ userProductId, success }: { userProductId: number; success: () => void }) {
  const { myStore } = useContext(StoresContext)
  const { closeModal } = useContext(ModalContext)

  const close = () => closeModal(MODALS_ID.CALCULATE)

  const calculate = async () => {
    try {
      await myStore.settlement(userProductId)
      success()
    } catch (error) {
      toast('매각 대금 정산에 실패했어요', error)
    }
    close()
  }

  return (
    <Modal id={MODALS_ID.CALCULATE}>
      <Text size={16} weight={500} lineHeight={24} block={true} $textAlign="center">
        매각 대금을 정산할까요?
      </Text>
      <Modal.Footer>
        <Button type="default" onClick={close}>
          아니요
        </Button>
        <Button type="primary" onClick={calculate}>
          네
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
